<template>
  <div class="support">
    <div class="support-item">
      <h2>主办单位</h2>
      <p>工业和信息化部</p>
      <p>教育部</p>
      <p>江苏省人民政府</p>
    </div>
    <div class="support-item">
      <h2>主办单位</h2>
      <p>工业和信息化部</p>
      <p>教育部</p>
      <p>江苏省人民政府</p>
    </div>
    <div class="support-item">
      <h2>主办单位</h2>
      <p>工业和信息化部</p>
      <p>教育部</p>
      <p>江苏省人民政府</p>
    </div>
    <div class="support-item">
      <h2>主办单位</h2>
      <p>工业和信息化部</p>
      <p>教育部</p>
      <p>江苏省人民政府</p>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.support {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  .support-item {
    width: 280px;
    height: 167px;
    display: block;
    float: left;
    padding-top: 5vh;
    padding-left: 8vh;
    color: #fff;
    h2 {
      color: #fff;
      font-size: 16px;
      text-align: left;
      margin-bottom: 15px;
    }
    p {
      color: #c8c8c8;
      font-size: 12px;
      text-align: left;
      line-height: 15px;
    }
  }
}
</style>
